import ProductsListPresenter from "../../products-list/presenter/products-list.js";
import CartProductItemPresenter from "./cart-product-item.js";

import {
  debounce
} from "../../../utils/debounce.js";

import {
  TABLET_MEDIA_QUERY,
  ActionType
} from "../const.js";

export default class CartProductsList extends ProductsListPresenter {
  constructor(listElement) {
    super(listElement);

    this._itemPresenterArgs = [
      this
    ];

    this._ProductItemPresenter = CartProductItemPresenter;

    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._handleWindowResizeDebounced = debounce(this._handleWindowResize);
  }

  init() {
    super.init();

    this._changeLayout();
    window.addEventListener(`resize`, this._handleWindowResizeDebounced);
  }

  removeItem(presenter) {
    const presenterToRemoveKey = Object.entries(this._itemsPresenter)
      // eslint-disable-next-line no-unused-vars
      .find(([key, item]) => {
        return item === presenter;
      })[0];

    delete this._itemsPresenter[presenterToRemoveKey];

    if (window.CartData) {
      const action = (Object.keys(this._itemsPresenter).length > 0) ?
        ActionType.REMOVE_FROM_LIST :
        ActionType.CLEAR;

      window.CartData.changeData(Object.assign(
          {},
          window.CartData.getData(),
          {
            totalPositions: Object.keys(this._itemsPresenter).length
          }
      ), action);
    }
  }

  _changeLayout() {
    if (window.matchMedia(TABLET_MEDIA_QUERY).matches) {
      Object.values(this._itemsPresenter)
        .forEach((presenter) => presenter.adjustLayout());
    } else {
      Object.values(this._itemsPresenter)
      .forEach((presenter) => presenter.resetCartItemView());
    }
  }

  _handleWindowResize() {
    this._changeLayout();
  }
}
